import React from 'react';
import { createRoot } from 'react-dom/client';

import SearchDesktop from '@/components/SearchDesktop';

export default (
  lang: string,
  translations: {
    sale: string;
    rental: string
  },
  sale: Array<{
    id: number;
    name: string;
    slug: string
  }>,
  rental: Array<{
    id: number;
    name: string;
    slug: string
  }>
): void => {
  const container = document.getElementById('ssr-search-home');

  if (!container) {
    return;
  }

  const root = createRoot(container);

  const placeholder = container
    .querySelector<HTMLInputElement>('input')
    ?.getAttribute('placeholder') ?? '';

  root.render(
    <SearchDesktop
      lang={lang}
      sale={sale}
      rental={rental}
      translations={translations}
      placeholder={placeholder}
    />
  );
};
